module.exports = new __parcel__URL__("pirates-of-silicon-valley.b5b25eb3.jpg").toString();